var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'group': true,
    'collapse': _vm.collapsible,
    'shown': !_vm.internalCollapsed,
    'hidden': _vm.internalCollapsed,
  }},[(_vm.header)?_c('h1',{staticClass:"header group__header"},[(_vm.collapsible)?_c('button',{staticClass:"collapse-icon",attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickCollapse()}}},[_c('span',{class:{
        'ui-icon': true,
        'ui-icon-triangle-1-n': !_vm.internalCollapsed,
        'ui-icon-triangle-1-s': _vm.internalCollapsed,
      }},[_vm._v(_vm._s(_vm.internalCollapsed ? 'Show Group Contents' : 'Hide Group Contents'))])]):_vm._e(),_c('span',{staticClass:"header__text"},[_vm._v(_vm._s(_vm.header))])]):_vm._e(),_c('div',{staticClass:"rect group__inner"},[_vm._t("default"),_c('div',{staticClass:"clear"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }